import { RefundSettlementStatus } from '@/lib/enums/RefundSettlementStatus'
import type { RefundRequestStatusSnapshot } from './refunds.types'

/** The refund was accepted but its money didn't (all) move; the order page shows its settlement. */
export function isUnsettledRefund(status: RefundRequestStatusSnapshot | null | undefined): boolean {
  return (
    status?.settlement_status === RefundSettlementStatus.Failed.Value ||
    status?.settlement_status === RefundSettlementStatus.PartiallySettled.Value
  )
}

/** The refund's money is still on its way: the request stands, and the order page follows it to settlement. */
export function isPendingRefund(status: RefundRequestStatusSnapshot | null | undefined): boolean {
  return status?.settlement_status === RefundSettlementStatus.PendingSettlement.Value
}
